var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumberLicense(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 58,
    viewBox: "0 0 74 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(-407 -89)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    width: 74,
    height: 58,
    rx: 6,
    transform: "translate(407 89)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sim-card",
    transform: "translate(471.74 97.846) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3199",
    "data-name": "Path 3199",
    d: "M37.679,7.5H8.9A1.4,1.4,0,0,0,7.5,8.9V60.243a1.4,1.4,0,0,0,1.4,1.4H44.774a1.4,1.4,0,0,0,1.4-1.4v-44.8a1.4,1.4,0,0,0-.451-1.029L38.629,7.871A1.4,1.4,0,0,0,37.679,7.5Zm0,0",
    transform: "translate(-6.683 -6.683)",
    fill: "#e3f6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3200",
    "data-name": "Path 3200",
    d: "M245.4,14.418l-7.094-6.547a1.4,1.4,0,0,0-.95-.372H231.59l7.306,6.742a1.993,1.993,0,0,1,.641,1.464V61.644h4.914a1.4,1.4,0,0,0,1.4-1.4v-44.8A1.4,1.4,0,0,0,245.4,14.418Zm0,0",
    transform: "translate(-206.36 -6.683)",
    fill: "#cee8f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3201",
    "data-name": "Path 3201",
    d: "M68.921,151.733H47.482A4.783,4.783,0,0,1,42.7,146.95V118.337a4.783,4.783,0,0,1,4.783-4.782H68.921a4.783,4.783,0,0,1,4.783,4.782V146.95A4.783,4.783,0,0,1,68.921,151.733Zm0,0",
    transform: "translate(-38.048 -101.184)",
    fill: "#ffcc3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3202",
    "data-name": "Path 3202",
    d: "M68.921,151.733H47.482A4.783,4.783,0,0,1,42.7,146.95V118.337a4.783,4.783,0,0,1,4.783-4.782H68.921a4.783,4.783,0,0,1,4.783,4.782V146.95A4.783,4.783,0,0,1,68.921,151.733Zm0,0",
    transform: "translate(-38.048 -101.184)",
    fill: "#ffcc3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3203",
    "data-name": "Path 3203",
    d: "M270.77,113.555h-1.544v38.178h1.544a4.783,4.783,0,0,0,4.783-4.783V118.337A4.783,4.783,0,0,0,270.77,113.555Zm0,0",
    transform: "translate(-239.897 -101.184)",
    fill: "#efb525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3204",
    "data-name": "Path 3204",
    d: "M142.024,126.485H147.5a2.184,2.184,0,0,0,2.184-2.184V113.555h-9.84V124.3A2.184,2.184,0,0,0,142.024,126.485Zm0,0",
    transform: "translate(-124.606 -101.184)",
    fill: "#ffd876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3205",
    "data-name": "Path 3205",
    d: "M147.5,345.313h-5.473a2.184,2.184,0,0,0-2.184,2.184v10.746h9.84V347.5A2.184,2.184,0,0,0,147.5,345.313Zm0,0",
    transform: "translate(-124.606 -307.694)",
    fill: "#ffd876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3206",
    "data-name": "Path 3206",
    d: "M39.594,7.134,32.5.588A2.21,2.21,0,0,0,31,0H2.218A2.22,2.22,0,0,0,0,2.218V53.56a2.22,2.22,0,0,0,2.218,2.218H38.091a2.22,2.22,0,0,0,2.218-2.218V8.764A2.224,2.224,0,0,0,39.594,7.134Zm-.92,46.426a.584.584,0,0,1-.583.583H2.218a.584.584,0,0,1-.583-.583V2.218a.584.584,0,0,1,.583-.583H31a.581.581,0,0,1,.4.155l7.094,6.547a.585.585,0,0,1,.188.429Zm0,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3207",
    "data-name": "Path 3207",
    d: "M62.238,106.055H40.8a5.606,5.606,0,0,0-5.6,5.6v28.613a5.606,5.606,0,0,0,5.6,5.6H62.238a5.606,5.606,0,0,0,5.6-5.6V111.654A5.606,5.606,0,0,0,62.238,106.055Zm-25.4,5.6a3.97,3.97,0,0,1,3.966-3.965h4.982v2.992a.817.817,0,0,0,1.634,0v-2.992h8.206v9.929a1.368,1.368,0,0,1-.058.394c-.007.02-.014.04-.02.06a1.37,1.37,0,0,1-1.289.913H48.782a1.369,1.369,0,0,1-1.289-.913c-.006-.02-.012-.04-.02-.06a1.354,1.354,0,0,1-.058-.394V114.5a.817.817,0,1,0-1.634,0v2.982h-.375a7.782,7.782,0,0,0-7.1,4.606.345.345,0,0,1-.315.2h-1.16Zm8.948,32.579H40.8a3.97,3.97,0,0,1-3.966-3.966V129.634h1.16a.344.344,0,0,1,.315.2,7.783,7.783,0,0,0,7.1,4.606h.374ZM66.2,140.267a3.97,3.97,0,0,1-3.966,3.966H57.256v-3.286a.817.817,0,0,0-1.634,0v3.286H47.415V134.3a1.368,1.368,0,0,1,.058-.394c.007-.02.014-.04.02-.06a1.369,1.369,0,0,1,1.289-.913h5.473a1.37,1.37,0,0,1,1.289.913c.006.02.012.041.02.06a1.368,1.368,0,0,1,.057.394v2.829a.817.817,0,1,0,1.634,0v-2.689h.375a7.782,7.782,0,0,0,7.1-4.606.344.344,0,0,1,.315-.2H66.2ZM66.2,128h-1.16a1.981,1.981,0,0,0-1.807,1.17,6.147,6.147,0,0,1-5.605,3.638h-.774a3,3,0,0,0-2.6-1.506H48.782a3,3,0,0,0-2.6,1.506h-.774A6.146,6.146,0,0,1,39.8,129.17,1.981,1.981,0,0,0,37.994,128h-1.16v-4.079h1.16a1.981,1.981,0,0,0,1.807-1.17,6.147,6.147,0,0,1,5.605-3.638h.774a3,3,0,0,0,2.6,1.506h5.473a3,3,0,0,0,2.6-1.506h.774a6.146,6.146,0,0,1,5.605,3.638,1.981,1.981,0,0,0,1.808,1.17H66.2Zm0-5.713h-1.16a.345.345,0,0,1-.315-.2,7.782,7.782,0,0,0-7.1-4.606h-.375v-9.79h4.982a3.97,3.97,0,0,1,3.966,3.965Zm0,0",
    transform: "translate(-31.365 -94.501)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberLicense);
export default __webpack_public_path__ + "static/media/numberLicense.41e8777ec6cdb4527d49b99f8bcbbbdd.svg";
export { ForwardRef as ReactComponent };